(function trackVariant() {
    console.log("tracking for conversion")
  const variant = 'conversion'; // change per page
  if (typeof gtag === 'function') {
    gtag('event', 'landing_variant_viewed', {
      landing_variant: variant
    });
  } else {
    setTimeout(trackVariant, 300);
  }
})();
